document.addEventListener("DOMContentLoaded", function () {
  // Funktion liefert den Monatsnamen
  function getMonthName(month) {
    const months = [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"
    ];
    return months[month - 1] || "Unbekannter Monat";
  }

  // Mapping der Fabrikcodes zu Ländern
  function getLocationName(prefix) {
    const mapping = {
      // Deutschland
      "LP": "Deutschland",
      "OL": "Deutschland",
      // Frankreich
      "A0": "Frankreich",
      "A1": "Frankreich",
      "A2": "Frankreich",
      "AA": "Frankreich",
      "AAS": "Frankreich (Auftragsarbeit)",
      "AH": "Frankreich",
      "AN": "Frankreich",
      "AR": "Frankreich",
      "AS": "Frankreich",
      "BA": "Frankreich",
      "BJ": "Frankreich",
      "BU": "Frankreich",
      "DR": "Frankreich",
      "DU": "Frankreich",
      "DT": "Frankreich",
      "CO": "Frankreich",
      "CT": "Frankreich",
      "CX": "Frankreich",
      "ET": "Frankreich",
      "FL": "Frankreich",
      "LA": "Frankreich",
      "LW": "Frankreich",
      "MB": "Frankreich",
      "ML": "Frankreich",
      "MI": "Frankreich",
      "NO": "Frankreich",
      "RA": "Frankreich",
      "RI": "Frankreich",
      "SA": "Frankreich",
      "SD": "Frankreich",
      "SF": "Frankreich",
      "SL": "Frankreich",
      "SN": "Frankreich",
      "SP": "Frankreich",
      "SR": "Frankreich",
      "TA": "Frankreich",
      "TJ": "Frankreich",
      "TH": "Frankreich",
      "TN": "Frankreich",
      "TR": "Frankreich",
      "TS": "Frankreich",
      "VI": "Frankreich",
      "VX": "Frankreich",
      // Italien
      "BC": "Italien",
      "BO": "Italien",
      "CE": "Italien",
      "FN": "Italien",
      "FO": "Italien",
      "MA": "Italien",
      "NZ": "Italien",
      "OB": "Italien",
      "PL": "Italien",
      "RC": "Italien",
      "RE": "Italien",
      "TD": "Italien",
      // Schweiz
      "DI": "Schweiz",
      "FA": "Schweiz",
      // Spanien
      "CA": "Spanien",
      "UB": "Spanien",
      "LO": "Spanien",
      "LB": "Spanien",
      "LM": "Spanien",
      "LW": "Spanien",
      "GI": "Spanien",
      // USA
      "FC": "USA",
      "FH": "USA",
      "LA": "USA",
      "OS": "USA",
      "SD": "USA",
      "FL": "USA",
      "TX": "USA"
    };
    return mapping[prefix] || prefix;
  }

  // Verarbeitung von Vor-1990-Codes (Format: 3 oder 4 Ziffern, evtl. gefolgt von 2 Buchstaben)
  function checkPre1990Code(code) {
    // Erlaubtes Format z. B. "826" oder "8810AR"
    const regex = /^(\d{3,4})([A-Z]{0,2})$/i;
    const match = code.match(regex);
    if (!match) {
      return { valid: false, message: "Ungültiges Format für Vor-1990 Code" };
    }
    const numericPart = match[1];
    const factory = match[2] ? match[2].toUpperCase() : "";
    // Die ersten zwei Ziffern ergeben das Jahr (immer 1900 + Ziffern)
    const year = 1900 + parseInt(numericPart.slice(0, 2), 10);
    // Nur gültig, wenn 1980 ≤ Jahr ≤ 1989
    if (year < 1980 || year >= 1990) {
      return { valid: false, message: "Jahr im Code liegt nicht zwischen 1980 und 1989" };
    }
    // Der Rest sind die Ziffern für den Monat
    const month = parseInt(numericPart.slice(2), 10);
    if (isNaN(month) || month < 1 || month > 12) {
      return { valid: false, message: "Ungültiger Monat im Code" };
    }
    let msg = `Hergestellt im ${getMonthName(month)} ${year}`;
    if (factory) {
      msg += ` in ${getLocationName(factory)} (${factory})`;
    }
    return { valid: true, message: msg };
  }

  // Verarbeitung von Post-1990-Codes (Format: 2 Buchstaben + 4 Ziffern)
  function checkPost1990Code(code) {
    const regex = /^[A-Z]{2}\d{4}$/;
    if (!regex.test(code)) {
      return { valid: false, message: "Ungültiges Format. Bitte 2 Buchstaben gefolgt von 4 Zahlen eingeben." };
    }
    const factory = code.slice(0, 2);
    const digits = code.slice(2);

    // Berechnung der monat-basierten Variante (1990 bis 2006)
    let monthBasedMonth = parseInt(digits.charAt(0) + digits.charAt(2), 10);
    let monthBasedYearDigits = digits.charAt(1) + digits.charAt(3);
    let monthBasedYear = (parseInt(monthBasedYearDigits, 10) >= 90)
      ? 1900 + parseInt(monthBasedYearDigits, 10)
      : 2000 + parseInt(monthBasedYearDigits, 10);
    let isMonthBasedValid = (monthBasedYear >= 1990 && monthBasedYear <= 2006 && monthBasedMonth >= 1 && monthBasedMonth <= 12);

    // Berechnung der kalenderwochenbasierten Variante (2007 bis 2021)
    let weekBasedWeek = parseInt(digits.charAt(0) + digits.charAt(2), 10);
    let weekBasedYear = 2000 + parseInt(digits.charAt(1) + digits.charAt(3), 10);
    let isWeekBasedValid = (weekBasedYear >= 2007 && weekBasedYear <= 2021 && weekBasedWeek >= 1 && weekBasedWeek <= 52);

    if (isMonthBasedValid && !isWeekBasedValid) {
      return {
        valid: true,
        message: `Hergestellt im ${getMonthName(monthBasedMonth)} ${monthBasedYear} in ${getLocationName(factory)} (${factory})`
      };
    } else if (!isMonthBasedValid && isWeekBasedValid) {
      return {
        valid: true,
        message: `Hergestellt in der ${weekBasedWeek}. Kalenderwoche im Jahr ${weekBasedYear} in ${getLocationName(factory)} (${factory})`
      };
    } else if (isMonthBasedValid && isWeekBasedValid) {
      // Sollte theoretisch nicht auftreten – hier disambiguieren wir anhand des Jahres
      if (monthBasedYear < 2007) {
        return {
          valid: true,
          message: `Hergestellt im ${getMonthName(monthBasedMonth)} ${monthBasedYear} in ${getLocationName(factory)} (${factory})`
        };
      } else {
        return {
          valid: true,
          message: `Hergestellt in der ${weekBasedWeek}. Kalenderwoche im Jahr ${weekBasedYear} in ${getLocationName(factory)} (${factory})`
        };
      }
    } else {
      return { valid: false, message: "Unbekanntes Datumscode-Format oder Datum außerhalb des erwarteten Bereichs." };
    }
  }

  // Hauptfunktion, die entscheidet, welche Logik angewendet wird
  function checkLVCode(code) {
    code = code.trim().toUpperCase();
    if (!code) {
      return { valid: false, message: "Bitte geben Sie einen Datacode ein." };
    }
    // Vor-1990: beginnt mit einer Ziffer
    if (/^\d/.test(code)) {
      return checkPre1990Code(code);
    }
    // Post-1990: beginnt mit Buchstaben
    return checkPost1990Code(code);
  }

  // Event-Listener für den Button
  document.getElementById("check-code").addEventListener("click", function () {
    const userCode = document.getElementById("user-code").value;
    const resultElement = document.getElementById("result");
    const result = checkLVCode(userCode);
    resultElement.textContent = result.message;
  });
});
